import Immutable from 'immutable';
import { COLLECTION_SHAPE } from '../../../config/shapes';
import { 
  CLEAR_ENDPOINT,
  CLEAR_ENDPOINTS, 
  FLAG_ENDPOINT_ENDPOINT, 
  FLAG_GETTING_ENDPOINTS, 
  GET_ENDPOINT, 
  GET_ENDPOINTS 
} from '../../../actions/types/security/Endpoint';

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
      content: Immutable.Map(),
      activity: Immutable.List(),
    }),
});

export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_ENDPOINTS:
      return state.setIn(['all', 'loading'], payload);
    case GET_ENDPOINTS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_ENDPOINTS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_ENDPOINT_ENDPOINT:
      if (payload) {
        return state.setIn(
          ['current', 'activity'],
          state.getIn(['current', 'activity']).push(payload),
        );
      }

      return state.setIn(
        ['current', 'activity'],
        state.getIn(['current', 'activity']).pop(),
      );
    case GET_ENDPOINT:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_ENDPOINT:
      return state.setIn(
        ['current', 'content'],
        INITIAL_STATE.getIn(['current', 'content']),
      );
    default:
      return state;
  }
};
